import React, { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import { Formik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import parse from "date-fns/parse";
import { Button } from "../../components/ui/button";
import DialogModal from "../../components/partials/modal/dialogModal";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { ChevronDown, Edit, Trash2, View, Clock } from "lucide-react";
//import "../../assets/nascent.css";
import { useNavigate } from "react-router-dom";
import common from "../../helper/common";
import {
  BookingStatusEnum,
  BookingModeEnum,
  DateminFormat,
  PaymentStatusEnum,
  respEnum,
  ToCSharpFormat,
  IntMax,
  IntMinLevel,
  SlotStatusEnum,
  AppUserSettingsTypeEnum,
} from "../../constants/appConstant";
import AddBooking from "../clubbookings/components/addBooking";
import moment from "moment";
import { AppInput, AppSelect } from "../../components/appComponents";
import AddUpdateModal from "../../components/formComponents/addUpdateModal";
import { useQueryParams } from "../../contexts/queryParamsContext";
import Common from "../../helper/common";
import {
  FormikInput,
  FormikSearchSectionSelect,
  FormikSearchSelect,
  FormikDate,
  FormikTextArea,
} from "../../components/formik-components";
import { useDispatch, useSelector } from "react-redux";
import { setCalendarDate, setSportId } from "../../store/bookingSlice";
import html2canvas from "html2canvas";
import { Icon } from "@iconify/react";
import { jsPDF } from "jspdf";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const BookingCalendar2 = () => {
  const [events, setEvents] = useState([]);
  const [booking, setBooking] = useState([]);
  const [resources, setResources] = useState([]);
  const [courtList, setCourtList] = useState([]);
  // const [selectedSport, setSelectedSport] = useState(null);
  // const [selectedDate, setSelectedDate] = useState(new Date());
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [sports, setSports] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [ShowCancelBooking, setShowCancelBooking] = useState(false);
  const [showTimeModal, setShowTimeModal] = useState(false);
  const [bookingValues, setBookingValues] = useState({});
  const [selectedBooking, setSelectedBooking] = useState([]);
  const [cancellationReasons, setCancellationReasons] = useState([]);
  const navigate = useNavigate();
  let courtChargesDisabled = true;

  const dispatch = useDispatch();
  const { calendarDate: selectedDate, sportId: selectedSport } = useSelector(
    (state) => state.booking
  );

  const handleDateChange = (date) => {
    dispatch(setCalendarDate(date));
  };

  const handleSportChange = (sportIdValue) => {
    dispatch(setSportId(sportIdValue));
  };

  // const [params, setParams] = useState({});
  const { params, setParams } = useQueryParams();

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      @media (min-width: 768px) {
        .resource-fixed {
          position: fixed;
          top: 60px;
          z-index: 999;
          background: white;
        }
      }
    `;
    document.head.appendChild(style);

    const handleScroll = () => {
      if (window.innerWidth < 768) return;

      const resourceRows = document.querySelectorAll(
        ".rbc-row.rbc-row-resource"
      );
      if (!resourceRows.length) return;

      if (window.scrollY >= 150) {
        resourceRows.forEach((row) => row.classList.add("resource-fixed"));
      } else {
        resourceRows.forEach((row) => row.classList.remove("resource-fixed"));
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    GetSports();
    getCourts();
    getCancellationReasons();
  }, []);

  useEffect(() => {
    if (selectedSport !== undefined && selectedSport !== null) {
      fetchCourtWiseBookings();
    }
  }, [selectedSport, selectedDate]);

  // Additional effect to handle sport selection when sports list is loaded
  useEffect(() => {
    if (sports.length > 1 && selectedSport !== null) {
      // Validate that the selected sport exists in the sports list
      const sportExists = sports.some(
        (sport) => sport.id === selectedSport || sport.value === selectedSport
      );
      if (!sportExists && selectedSport !== null) {
        // If selected sport doesn't exist, reset to first sport
        const firstSportId = sports[1].id || sports[1].value;
        if (firstSportId) {
          handleSportChange(firstSportId);
        }
      }
    }
  }, [sports, selectedSport]);

  const formCancelValidations = yup.object({
    cancellationreasonid: yup
      .number()
      .nullable()
      .when([], {
        is: () => selectedBooking?.bookingMode === BookingModeEnum.App_Booking,
        then: (schema) =>
          schema.required("Cancellation reason is required for App Bookings"),
        otherwise: (schema) => schema.nullable().optional(),
      }),
    reason: yup.string().when("cancellationreasonid", {
      is: (val) => {
        const selectedReasonData = cancellationReasons.find(
          (r) => r.value === val
        );
        return selectedReasonData?.isOther === true;
      },
      then: (schema) =>
        schema.required("Please specify the reason").min(1).max(50),
      otherwise: (schema) => schema.optional(),
    }),
  });

  const formRescheduleValidations = yup.object({
    courtId: yup.object().required("Court is Requied"),
    bookingDate: yup
      .date()
      .required("Booking Date is Requied")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)),
        "Date should not be earlier than today"
      ),
    startDateTime: yup
      .string()
      .required("Start Time is required")
      .test(
        "is-valid-time",
        "Start Time format should be in 00, 30 or 23:59 format",
        (value) => Common.Utility.CheckTime(value)
      )
      .matches(
        /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
        "Invalid time format (HH:mm)"
      ),

    endDateTime: yup
      .string()
      .required("End time is required")
      .test(
        "is-valid-time",
        "End Time format should be in 00, 30 23:59 format",
        (value) => Common.Utility.CheckTime(value)
      )
      .matches(
        /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
        "Invalid time format (HH:mm)"
      ),

    courtcharges: yup.number().optional(),
  });

  const formTimeInputValidations = yup.object({
    startDateTime: yup
      .date()
      .required("Start Date Time is required")
      .test(
        "is-valid-time",
        "Time must be in 00 or 30 minute intervals",
        (value) => {
          if (!value) return true;
          const minutes = moment(value).minute();
          return minutes === 0 || minutes === 30;
        }
      ),
    endDateTime: yup
      .date()
      .required("End Date Time is required")
      .test(
        "is-valid-time",
        "Time must be in 00, 30 minute intervals or 23:59",
        (value) => {
          if (!value) return true;
          const timeMoment = moment(value);
          const minutes = timeMoment.minute();
          const hours = timeMoment.hour();
          // Allow 00, 30 minutes or 23:59
          return (
            minutes === 0 || minutes === 30 || (hours === 23 && minutes === 59)
          );
        }
      )
      .test(
        "is-after-start",
        "End Date Time must be after Start Date Time",
        function (value) {
          const { startDateTime } = this.parent;
          return (
            !startDateTime ||
            !value ||
            dayjs(value).isAfter(dayjs(startDateTime))
          );
        }
      )
      .test(
        "max-24-hours",
        "Date range cannot exceed 24 hours",
        function (value) {
          const { startDateTime } = this.parent;
          if (!startDateTime || !value) return true;
          const diffHours = dayjs(value).diff(dayjs(startDateTime), "hour");
          return diffHours <= 24;
        }
      ),
  });

  const GetSports = async () => {
    try {
      const response = await common.ApiService.getInstance().request(
        "GetClubSports"
      );
      const sportsData = [
        { id: null, name: "Select Sport", value: null, label: "Select Sport" },
        ...(response?.data ?? []).map((sport) => ({
          id: sport.id,
          name: sport.name,
          value: sport.id,
          label: sport.name,
        })),
      ];

      setSports(sportsData);

      // Only set first sport if no sport is already selected in Redux
      if (sportsData.length > 1 && selectedSport === null) {
        const firstSportId = sportsData[1].id;
        handleSportChange(firstSportId);
      }
    } catch (error) {
      console.error("Error fetching sports:", error);
    }
  };

  const getCourts = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetSportWiseCourtddl"
    );
    if (response?.status == respEnum.Success) {
      setCourtList(response?.data ?? []);
    }
  };

  const fetchCourtWiseBookings = async () => {
    try {
      const formattedDate = moment(selectedDate).format("yyyy-MM-DD");
      const response = await common.ApiService.getInstance().request(
        `GetCourtWiseBookingsByDate?sportId=${selectedSport}&date=${formattedDate}`
      );

      if (response.status === respEnum.Success) {
        const calendarResources = [];
        const calendarEvents = [];
        const bookingEvent = [];

        const allBookings = response.data.flatMap((court) => {
          calendarResources.push({
            id: court.courtId,
            title: court.courtName,
          });

          const bookings = court.bookings ?? [];

          return bookings
            .filter((b) => b != null)
            .map((booking) => {
              const common = {
                id: booking.id,
                title: booking.playerName,
                courtId: court.courtId,
                startDateTime: booking.startDateTime,
                endDateTime: booking.endDateTime,
                discountAmount: booking.discountAmount,
                courtcharges: booking.courtcharges,
                total: booking.total,
                paymentStatus: booking.paymentStatus,
                slotStatus: booking.slotStatus,
                holidayReason: booking.holidayReason,
                sportId: booking.sportId,
              };

              calendarEvents.push({
                ...common,
                start: new Date(common.startDateTime),
                end: new Date(common.endDateTime),
                resourceId: court.courtId,
              });

              bookingEvent.push({
                ...common,
                bookingDate: common.startDateTime.split("T")[0],
              });

              return null;
            });
        });

        setEvents(calendarEvents);
        setBooking(bookingEvent);
        setResources(calendarResources);
      }
      // if (response.status == respEnum.Success) {
      //   const calendarEvents = response.data.flatMap((court) =>
      //     (court.bookings ?? [])
      //       .filter(b => b != null)
      //       .map((booking) => ({
      //         id: booking.id,
      //         title: booking.playerName,
      //         start: new Date(booking.startDateTime),
      //         end: new Date(booking.endDateTime),
      //         resourceId: court.courtId,
      //         paymentStatus: booking.paymentStatus,
      //         startDateTime: booking.startDateTime,
      //         discountAmount: booking.discountAmount,
      //         courtcharges: booking.courtcharges,
      //         total: booking.total,
      //         slotStatus: booking.slotStatus,
      //         holidayReason: booking.holidayReason,
      //       }))
      //   );

      //   const bookingEvent = response.data.flatMap((court) =>
      //     (court.bookings ?? [])
      //       .filter(b => b != null)
      //       .map((booking) => ({
      //         id: booking.id,
      //         title: booking.playerName,
      //         bookingDate: booking.startDateTime.split("T")[0],
      //         startDateTime: booking.startDateTime,
      //         endDateTime: booking.endDateTime,
      //         courtId: court.courtId,
      //         discountAmount: booking.discountAmount,
      //         courtcharges: booking.courtcharges,
      //         total: booking.total,
      //         paymentStatus: booking.paymentStatus,
      //         sportId: booking.sportId,
      //         slotStatus: booking.slotStatus,
      //         holidayReason: booking.holidayReason,
      //       }))
      //   );

      //   const calendarResources = response.data.map((court) => ({
      //     id: court.courtId,
      //     title: court.courtName,
      //   }));

      //   setEvents(calendarEvents);
      //   setBooking(bookingEvent);
      //   setResources(calendarResources);
      // }
    } catch (error) {
      console.error("Error fetching court bookings:", error);
    }
  };

  const getCancellationReasons = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetCancellationReasonDDL"
    );

    if (response?.status == respEnum.Success) {
      setCancellationReasons(response?.data || []);
    }
  };

  const handleNavigate = (newDate, view, action) => {
    handleDateChange(newDate);
  };

  // Add new event
  const handleSelect = ({ start, end, resourceId }) => {
    setShowAdd(true);

    setBookingValues({
      courtId: resourceId,
      startDateTime: moment(new Date(start)).format("HH:mm"),
      endDateTime: moment(new Date(end)).format("HH:mm"),
    });
  };

  // Edit event
  // const handleEditEvent = (event) => {
  //   const newTitle = window.prompt("Edit Event name", event.title);
  //   if (newTitle !== null) {
  //     setEvents(
  //       events.map((evt) =>
  //         evt.id === event.id ? { ...evt, title: newTitle } : evt
  //       )
  //     );
  //     setOpenDropdownId(null);
  //   }
  // };

  // Cancel/Delete event
  // const handleCancelEvent = (event) => {
  //   const confirmCancel = window.confirm(
  //     "Are you sure you want to cancel this event?"
  //   );
  //   if (confirmCancel) {
  //     setEvents(events.filter((evt) => evt.id !== event.id));
  //     setOpenDropdownId(null);
  //   }
  // };

  const cancelledBooking = async (d) => {
    let data = {
      ...d,
      bookingId: +selectedBooking?.id,
      status: +BookingStatusEnum.Cancelled_By_Club,
      cancellationreasonid: d.cancellationreasonid || null,
    };

    // Always send reasonId if a reason is selected
    if (d.cancellationreasonid) {
      data.reasonId = d.cancellationreasonid;

      // Find the selected reason to check if it's "Other"
      const selectedReasonData = cancellationReasons.find(
        (r) => r.value === d.cancellationreasonid
      );

      // If it's an "Other" reason, send the text from the reason textbox
      if (selectedReasonData?.isOther && d.reason) {
        data.reason = d.reason;
      } else {
        // For non-"Other" reasons, send the reason label
        data.reason = selectedReasonData?.label || "";
      }
    }

    let resp = await common.ApiService.getInstance().request(
      "UpdateBookingStatus",
      data,
      "Patch"
    );
    if (resp.status == respEnum.Success) {
      setShowCancelBooking(false);
      common.SweetAlert.alert("Booking Cancelled Successfully", "success");
      setEvents(events.filter((evt) => evt.id !== selectedBooking.id));

      //setEvents(events.filter((evt) => evt.id !== event.id));
      setOpenDropdownId(null);
    }
  };

  const _handleOnClose = (shouldRefresh) => {
    setShowAdd(false);
    if (shouldRefresh) {
      fetchCourtWiseBookings();
    }
  };

  const Reschedule = async (d) => {
    // Manual validation for court charges when duration changes
    if (selectedBooking?.paymentStatus == PaymentStatusEnum.Un_Paid) {
      const bookingDate = dayjs(d.bookingDate).format("YYYY-MM-DD");
      const newStartDateTime = dayjs(
        `${bookingDate} ${d.startDateTime}`,
        "YYYY-MM-DD HH:mm"
      );
      const newEndDateTime = dayjs(
        `${bookingDate} ${d.endDateTime}`,
        "YYYY-MM-DD HH:mm"
      );

      const originalDuration = dayjs(selectedBooking?.endDateTime).diff(
        dayjs(selectedBooking?.startDateTime),
        "minute"
      );
      const newDuration = newEndDateTime.diff(newStartDateTime, "minute");

      const isDurationChanged =
        newDuration !== originalDuration - 1 &&
        newDuration !== originalDuration &&
        originalDuration !== newDuration - 1;

      // Manual validation for court charges when duration changes
      if (isDurationChanged) {
        if (!d.courtcharges || d.courtcharges === "" || d.courtcharges <= 0) {
          toast.error("New court charges are required when duration changes");
          return;
        }
        if (d.courtcharges > IntMax) {
          toast.error(`Court charges cannot be greater than ${IntMax}`);
          return;
        }
        if (!Number.isInteger(Number(d.courtcharges))) {
          toast.error("Please enter a whole number without decimal points");
          return;
        }
      }
    }

    let data = {
      bookingId: selectedBooking?.id,
      courtId: d.courtId.value,
      newStartDateTime: Common.moment(
        `${d.bookingDate} ${d.startDateTime}`
      ).format(ToCSharpFormat),
      newEndDateTime: Common.moment(`${d.bookingDate} ${d.endDateTime}`).format(
        ToCSharpFormat
      ),
    };

    if (data.newStartDateTime >= data.newEndDateTime) {
      toast.error(`End time must be greater`);
      return;
    }

    const now = dayjs();
    if (
      dayjs(data.newStartDateTime).isBefore(now) ||
      dayjs(data.newEndDateTime).isBefore(now)
    ) {
      toast.error(`Start Time and End Time must not be in the past`);
      return;
    }

    if (data.courtId === selectedBooking.courtId) {
      if (
        data.newStartDateTime === selectedBooking.startDateTime &&
        data.newEndDateTime === selectedBooking.endDateTime
      ) {
        toast.error(
          "Rescheduling requires a change in either the start or end time"
        );
        return;
      }
    }

    const originalDuration = dayjs(selectedBooking?.endDateTime).diff(
      dayjs(selectedBooking?.startDateTime),
      "minute"
    );
    const newDuration = dayjs(data.newEndDateTime).diff(
      dayjs(data.newStartDateTime),
      "minute"
    );

    if (selectedBooking?.paymentStatus != PaymentStatusEnum.Un_Paid) {
      if (
        newDuration != originalDuration - 1 &&
        newDuration != originalDuration &&
        originalDuration != newDuration - 1
      ) {
        toast.error(
          `The duration must be (${originalDuration} minutes) when payment status is ${Common.Utility.getKeyByValue(
            PaymentStatusEnum,
            selectedBooking.paymentStatus
          )} `
        );
        return;
      }
    }

    if (
      selectedBooking?.paymentStatus == PaymentStatusEnum.Un_Paid &&
      newDuration != originalDuration - 1 &&
      newDuration != originalDuration &&
      originalDuration != newDuration - 1
    ) {
      if (!d.courtcharges) {
        toast.error(
          `Court charges are required as the new duration differs from the previous one.`
        );
        return;
      } else if (+d.courtcharges < selectedBooking?.discountAmount) {
        toast.error(`Discount must be less than Court charges`);
        return;
      } else {
        data.courtcharges = +d.courtcharges;
        data.discount = +d.discount;
      }
    }

    let resp = await Common.ApiService.getInstance().request(
      "BookingRescheduling",
      data,
      "POST"
    );
    if (resp.status == respEnum.Success) {
      setShowReschedule(false);
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        fetchCourtWiseBookings();
      }, 500);
    }
  };

  const _renderCancelBooking = () => (
    <div>
      <Formik
        onSubmit={cancelledBooking}
        validationSchema={formCancelValidations}
        enableReinitialize={false}
        initialValues={{
          cancellationreasonid: null,
          reason: "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => {
          // Calculate if current selection is "Other" reason directly from formik values
          const currentReasonId = formikProps.values.cancellationreasonid;
          const currentReasonData = cancellationReasons.find(
            (r) => r.value === currentReasonId
          );
          const isOtherReason = currentReasonData?.isOther || false;

          const handleReasonChange = (reasonId) => {
            // force set the selected reason ID immediately
            formikProps.setFieldValue("cancellationreasonid", reasonId);

            // Find the selected reason data
            const selectedReasonData = cancellationReasons.find(
              (r) => r.value === reasonId
            );

            // If it's an "Other" reason, clear the reason textbox for user input
            if (selectedReasonData?.isOther) {
              formikProps.setFieldValue("reason", "");
            } else {
              // For non-"Other" reasons, set the reason label
              formikProps.setFieldValue(
                "reason",
                selectedReasonData?.label || ""
              );
            }
          };

          return (
            <>
              <div className="mb-4">
                <FormikSearchSelect
                  formikProps={formikProps}
                  name="cancellationreasonid"
                  label={`Reason ${
                    selectedBooking?.bookingMode === BookingModeEnum.App_Booking
                      ? "*"
                      : "(Optional)"
                  }`}
                  placeholder="Select a reason..."
                  data={cancellationReasons}
                  labelKey="label"
                  valueKey="value"
                  onChange={handleReasonChange}
                />
              </div>

              {isOtherReason && (
                <div className="mb-4">
                  <FormikTextArea
                    formikProps={formikProps}
                    name="reason"
                    placeholder="Please specify the reason..."
                    type="textarea"
                    label="Specify Reason *"
                    maxLength={50}
                  />
                </div>
              )}

              <div className="flex justify-end gap-3 mt-6 pt-6 border-t border-gray-200">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowCancelBooking(false);
                  }}
                  className="px-6 py-2 hover:bg-gray-50 transition-colors"
                >
                  <Icon icon="heroicons:x-mark" className="w-4 h-4 mr-2" />
                  Close
                </Button>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  className="px-6 py-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white shadow-lg hover:shadow-xl transition-all duration-200"
                >
                  <Icon icon="heroicons:x-circle" className="w-4 h-4 mr-2" />
                  Cancel Booking
                </Button>
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );

  const _renderReschedule = () => (
    <div>
      <Formik
        onSubmit={Reschedule}
        validationSchema={formRescheduleValidations}
        enableReinitialize
        initialValues={{
          title: selectedBooking?.title,
          bookingDate: selectedBooking?.startDateTime
            ? Common.moment(selectedBooking.startDateTime).format(DateminFormat)
            : Common.moment().format(DateminFormat),
          courtId: selectedBooking?.courtId
            ? courtList
                .flatMap((category) => category.options)
                .find((court) => court.value === selectedBooking.courtId) ||
              null
            : null,
          startDateTime: selectedBooking?.startDateTime
            ? Common.moment(selectedBooking.startDateTime).format("HH:mm")
            : "",
          endDateTime: selectedBooking?.endDateTime
            ? Common.moment(selectedBooking.endDateTime).format("HH:mm")
            : "",
          courtcharges: selectedBooking.courtcharges
            ? selectedBooking.courtcharges
            : "",
          discount: selectedBooking?.discountAmount
            ? selectedBooking.discountAmount
            : "",
          total: selectedBooking?.total ? selectedBooking.total : "",
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => {
          const checkDurationChange = (startTime = null, endTime = null) => {
            const currentStartTime =
              startTime || formikProps.values.startDateTime;
            const currentEndTime = endTime || formikProps.values.endDateTime;

            if (!currentStartTime || !currentEndTime) {
              return {
                isDurationChanged: false,
                newDuration: 0,
                originalDuration: 0,
              };
            }

            const bookingDate = dayjs(formikProps.values.bookingDate).format(
              "YYYY-MM-DD"
            );
            const newStartDateTime = dayjs(
              `${bookingDate} ${currentStartTime}`,
              "YYYY-MM-DD HH:mm"
            );
            const newEndDateTime = dayjs(
              `${bookingDate} ${currentEndTime}`,
              "YYYY-MM-DD HH:mm"
            );

            const originalDuration = dayjs(selectedBooking?.endDateTime).diff(
              dayjs(selectedBooking?.startDateTime),
              "minute"
            );
            const newDuration = newEndDateTime.diff(newStartDateTime, "minute");

            const isDurationChanged =
              newDuration !== originalDuration - 1 &&
              newDuration !== originalDuration &&
              originalDuration !== newDuration - 1;

            return { isDurationChanged, newDuration, originalDuration };
          };

          const { isDurationChanged } = checkDurationChange();
          const isCourtChargesEnabled =
            selectedBooking?.paymentStatus == PaymentStatusEnum.Un_Paid &&
            isDurationChanged;

          // Filter courts to only show courts from the same sport as the current booking
          const filteredCourtList = courtList.filter(
            (sport) => sport.value === selectedBooking?.sportId
          );

          return (
            <>
              <div className="mb-3">
                <FormikInput
                  formikProps={formikProps}
                  name={"title"}
                  label={"Player Name"}
                  disabled={true}
                />
              </div>

              <div className="mb-3">
                <FormikSearchSectionSelect
                  formikProps={formikProps}
                  name={"courtId"}
                  label={"Court"}
                  data={filteredCourtList}
                />
              </div>

              <div>
                <FormikDate
                  formikProps={formikProps}
                  name={"bookingDate"}
                  type={"date"}
                  label={"Booking Date"}
                  min={Common.moment().format("YYYY-MM-DD")}
                />
              </div>

              <div className="md:grid md:grid-cols-2 gap-6 items-center mt-4">
                <div className="flex flex-col">
                  <FormikInput
                    formikProps={formikProps}
                    name={"startDateTime"}
                    placeholder={"Start Time"}
                    label={"Start Time"}
                    type={"time"}
                    className="w-full"
                    onBlur={(event) => {
                      const value = event?.target?.value;
                      if (value) {
                        Common.Utility.handleBlur(value, "start Time", true);
                      }
                    }}
                    onChange={(value) => {
                      formikProps.setFieldValue("startDateTime", value);

                      const { isDurationChanged: newDurationChanged } =
                        checkDurationChange(
                          value,
                          formikProps.values.endDateTime
                        );

                      if (
                        selectedBooking?.paymentStatus ==
                        PaymentStatusEnum.Un_Paid
                      ) {
                        if (newDurationChanged) {
                          formikProps.setFieldValue("courtcharges", "");
                        } else {
                          formikProps.setFieldValue(
                            "courtcharges",
                            selectedBooking?.courtcharges || ""
                          );
                        }
                      }
                    }}
                  />
                </div>

                <div className="flex flex-col">
                  <FormikInput
                    formikProps={formikProps}
                    name={"endDateTime"}
                    placeholder={"End Time"}
                    label={"End Time"}
                    type={"time"}
                    className="w-full"
                    onBlur={(event) => {
                      const value = event?.target?.value;
                      if (value) {
                        Common.Utility.handleBlur(value, "end Time", true);
                      }
                    }}
                    onChange={(value) => {
                      formikProps.setFieldValue("endDateTime", value);

                      const { isDurationChanged: newDurationChanged } =
                        checkDurationChange(
                          formikProps.values.startDateTime,
                          value
                        );

                      if (
                        selectedBooking?.paymentStatus ==
                        PaymentStatusEnum.Un_Paid
                      ) {
                        if (newDurationChanged) {
                          formikProps.setFieldValue("courtcharges", "");
                        } else {
                          formikProps.setFieldValue(
                            "courtcharges",
                            selectedBooking?.courtcharges || ""
                          );
                        }
                      }
                    }}
                  />
                </div>
              </div>

              {selectedBooking?.paymentStatus == PaymentStatusEnum.Un_Paid && (
                <>
                  {isDurationChanged && (
                    <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                      <p className="text-sm text-yellow-800 font-medium">
                        Previous Court Charges: Rs.{" "}
                        {selectedBooking?.courtcharges || 0}
                      </p>
                      <p className="text-xs text-yellow-600 mt-1">
                        Duration has changed. Please enter new court charges.
                      </p>
                    </div>
                  )}

                  <div className="md:grid md:grid-cols-3 gap-6 items-center mt-4">
                    <div className="flex flex-col">
                      <FormikInput
                        formikProps={formikProps}
                        name={"courtcharges"}
                        placeholder={
                          isDurationChanged
                            ? "Enter new court charges"
                            : "Court Charges"
                        }
                        label={
                          isDurationChanged
                            ? "New Court Charges *"
                            : "Court Charges"
                        }
                        type={"number"}
                        max={IntMax}
                        disabled={!isCourtChargesEnabled}
                        min={1}
                        onChange={(value) => {
                          if (isCourtChargesEnabled) {
                            if (value < 1 && value !== "") {
                              formikProps.setFieldValue("courtcharges", 1);
                            } else if (value > IntMax) {
                              toast.error(
                                `Court charges cannot be greater than ${IntMax}`
                              );
                              formikProps.setFieldValue("courtcharges", "");
                            } else {
                              formikProps.setFieldValue("courtcharges", value);
                              // Auto-calculate total
                              const discountValue =
                                formikProps.values.discount || 0;
                              const total = (value || 0) - discountValue;
                              formikProps.setFieldValue("total", total);
                            }
                          }
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <FormikInput
                        formikProps={formikProps}
                        name={"discount"}
                        placeholder={"Discount"}
                        label={"Discount"}
                        type={"number"}
                        max={formikProps.values.courtcharges}
                        min={IntMinLevel}
                        disabled={true}
                      />
                    </div>
                    <div className="flex flex-col">
                      <FormikInput
                        formikProps={formikProps}
                        name={"total"}
                        placeholder={"Total"}
                        label={"Total"}
                        type={"number"}
                        disabled={true}
                        value={
                          (formikProps.values.courtcharges || 0) -
                          (formikProps.values.discount || 0)
                        }
                      />
                    </div>
                  </div>
                </>
              )}

              <div style={{ marginTop: "20px", textAlign: "right" }}>
                <Button
                  color="success"
                  onClick={(e) => {
                    e.preventDefault();
                    formikProps.handleSubmit();
                  }}
                  className="shadow-md mr-3"
                >
                  Reschedule
                </Button>

                <Button
                  color="secondary"
                  className="secondary"
                  onClick={() => setShowReschedule(false)}
                >
                  Close
                </Button>
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );

  const handleReschedule = (bookingId) => {
    const filteredBooking = booking.find((booking) => booking.id === bookingId);
    if (filteredBooking) setSelectedBooking(filteredBooking);
    setShowReschedule(true);
  };

  const handleCancel = (bookingId) => {
    const filteredBooking = booking.find((booking) => booking.id === bookingId);
    if (filteredBooking) setSelectedBooking(filteredBooking);
    setShowCancelBooking(true);
  };

  // Custom Event Component with Dropdown
  const CustomEvent = ({ event }) => {
    const isDropdownOpen = openDropdownId === event.id;

    return (
      <div className="relative ">
        <div className="flex items-center justify-between">
          <span
            className="truncate block"
            title={
              [
                SlotStatusEnum.Club_Holiday,
                SlotStatusEnum.Court_Holiday,
              ].includes(event.slotStatus)
                ? event.holidayReason
                : null
            }
          >
            {[
              SlotStatusEnum.Club_Holiday,
              SlotStatusEnum.Court_Holiday,
            ].includes(event.slotStatus)
              ? event.slotStatus === SlotStatusEnum.Club_Holiday
                ? "Club Closed"
                : "Court Closed"
              : event.title}
          </span>
          {/* <span className="truncate">{event.title}</span> */}

          {/* Only show dropdown toggle if it's not a holiday event */}
          {![
            SlotStatusEnum.Club_Holiday,
            SlotStatusEnum.Court_Holiday,
          ].includes(event.slotStatus) && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setOpenDropdownId(isDropdownOpen ? null : event.id);
              }}
              className="ml-2 text-gray-500 hover:text-gray-700 action-btn-dd"
            >
              <ChevronDown size={16} />
            </button>
          )}
        </div>

        {isDropdownOpen && (
          <div className="absolute z-10 right-0 mt-1 w-36 bg-white border rounded shadow-lg">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setParams({
                  ...params,
                  bookingId: event.id,
                });
                navigate(`/app/bookingDetails`);
              }}
              className="flex items-center w-full px-3 py-2 text-primary "
            >
              <View size={14} className="mr-2" /> View Details
            </button>
            {/* {moment(event?.startDateTime).isSameOrAfter(
              Common.Utility.GetCurrentDateTime()
            ) && ( */}
             {Common.Utility.ShowOnValidateDateOperation(
              event,
              "startDateTime",
              ">=",
              true,
              global.user.appUserSettings?.find(
                (setting) =>
                  setting.type === AppUserSettingsTypeEnum.Reschedule_Booking
              )?.value ||moment(event?.startDateTime).isSameOrAfter(
              Common.Utility.GetCurrentDateTime()
            )
            ) && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleReschedule(event.id);
                }}
                className="flex items-center w-full px-3 py-2 text-blue-600 hover:bg-gray-100"
              >
                <Clock size={14} className="mr-2" /> Reschedule
              </button>
            )}
            {Common.Utility.ShowOnValidateDateOperation(
              event,
              "startDateTime",
              ">=",
              true,
              global.user.appUserSettings?.find(
                (setting) =>
                  setting.type === AppUserSettingsTypeEnum.Cancel_Booking
              )?.value || 48
            ) && (
              <button
                onClick={async (e) => {
                  e.stopPropagation();

                  const isConfirmed = await common.SweetAlert.confirmation(
                    "Are you sure you want to cancel this booking? This can't be reversed!",
                    "Confirm Cancel"
                  );

                  if (isConfirmed) {
                    handleCancel(event.id);
                    //cancelledBooking(event);
                  }
                }}
                className="flex items-center w-full px-3 py-2 text-red-600 hover:bg-gray-100"
              >
                <Trash2 size={14} className="mr-2" /> Cancel Booking
              </button>
            )}
          </div>
        )}

        {showReschedule && (
          <DialogModal
            title={"Reschedule"}
            open={showReschedule}
            setOpen={setShowReschedule}
            Child={_renderReschedule}
            onClose={() => setShowReschedule(false)}
          />
        )}
        {ShowCancelBooking && (
          <DialogModal
            title={"Cancel Booking"}
            open={ShowCancelBooking}
            setOpen={setShowCancelBooking}
            Child={_renderCancelBooking}
            onClose={() => setShowCancelBooking(false)}
          />
        )}
      </div>
    );
  };

  const isSlotOverlapping = (slotInfo, events) => {
    return events.some(
      (event) =>
        // Check if the resource matches
        event.resourceId === slotInfo.resourceId &&
        // Check time overlap
        slotInfo.start < event.end &&
        slotInfo.end > event.start
    );
  };

  const getEventClassName = (event) => {
    let className = "payment-icon";

    if (event.paymentStatus === PaymentStatusEnum.Paid) {
      className += " pay-paid";
    } else if (event.paymentStatus === PaymentStatusEnum.Partial_Paid) {
      className += " pay-partial";
    } else if (event.paymentStatus === PaymentStatusEnum.Un_Paid) {
      className += " pay-unpaid";
    }

    // Holiday color override
    debugger;
    if (event.slotStatus === SlotStatusEnum.Club_Holiday) {
      className += " holiday-club";
    } else if (event.slotStatus === SlotStatusEnum.Court_Holiday) {
      className += " holiday-court";
    }

    return className;
  };

  const handleExportCalendar = async () => {
    try {
      toast.loading("Preparing calendar export...");

      // Create export container
      const exportContainer = document.createElement("div");
      exportContainer.style.position = "absolute";
      exportContainer.style.left = "-9999px";
      exportContainer.style.top = "-9999px";
      exportContainer.style.width = "1600px";
      exportContainer.style.backgroundColor = "#ffffff";
      exportContainer.style.padding = "20px";
      document.body.appendChild(exportContainer);

      // Get sport name
      let sportName = "";
      try {
        const sportSelect = document.querySelector('select[name="sportId"]');
        if (sportSelect && sportSelect.selectedIndex >= 0) {
          sportName =
            sportSelect.options[sportSelect.selectedIndex].text.trim();
        } else if (selectedSport && sports && sports.length > 0) {
          const sportObj = sports.find(
            (s) =>
              s.value?.toString() === selectedSport?.toString() ||
              s.id?.toString() === selectedSport?.toString()
          );
          if (sportObj) {
            sportName = sportObj.label || sportObj.name || sportObj.text;
          }
        }
      } catch (e) {
        console.error("Error getting sport name:", e);
      }

      // Add sport name header
      const header = document.createElement("h1");
      header.textContent = sportName || "Calendar";
      header.style.fontSize = "28px";
      header.style.fontWeight = "bold";
      header.style.color = "#0C1B3A";
      header.style.textAlign = "center";
      header.style.marginBottom = "20px";
      header.style.fontFamily = '"Segoe UI", "Roboto", sans-serif';
      exportContainer.appendChild(header);

      // Clone calendar
      const calendarElement = document.querySelector(".rbc-calendar");
      const calendarClone = calendarElement.cloneNode(true);

      // Preserve toolbar date but remove buttons
      const toolbar = calendarClone.querySelector(".rbc-toolbar");
      if (toolbar) {
        const btnGroups = toolbar.querySelectorAll(".rbc-btn-group");
        btnGroups.forEach((btnGroup) => btnGroup.remove());

        const toolbarLabel = toolbar.querySelector(".rbc-toolbar-label");
        if (toolbarLabel) {
          toolbarLabel.style.fontSize = "20px";
          toolbarLabel.style.fontWeight = "bold";
          toolbarLabel.style.margin = "0 auto 15px auto";
          toolbarLabel.style.textAlign = "center";
          toolbarLabel.style.width = "100%";
        }
      }

      // Fix court headers
      const headers = calendarClone.querySelectorAll(".rbc-header");
      headers.forEach((header) => {
        header.style.minWidth = "220px";
        header.style.width = "220px";
        header.style.padding = "10px 8px";
        header.style.fontSize = "16px";
        header.style.fontWeight = "bold";
        header.style.textAlign = "center";
        header.style.whiteSpace = "normal";
        header.style.overflow = "visible";
        header.style.backgroundColor = "#f8fafc";
      });

      // Fix resource cells
      const resourceCells = calendarClone.querySelectorAll(".rbc-row-resource");
      resourceCells.forEach((cell) => {
        cell.style.minWidth = "220px";
        cell.style.width = "220px";
        cell.style.padding = "8px";
        cell.style.fontSize = "14px";
        cell.style.fontWeight = "bold";
        cell.style.textAlign = "center";
        cell.style.backgroundColor = "#f8fafc";
      });

      // Fix calendar events for better readability
      const events = calendarClone.querySelectorAll(".rbc-event");
      events.forEach((event) => {
        // Remove dropdown buttons
        const dropdownButtons = event.querySelectorAll(
          "button, .action-btn-dd"
        );
        dropdownButtons.forEach((btn) => btn.remove());

        // Remove dropdowns
        const dropdowns = event.querySelectorAll(
          '.absolute, [style*="position: absolute"]'
        );
        dropdowns.forEach((dropdown) => dropdown.remove());

        // Enhanced styling for readability
        event.style.padding = "5px";
        event.style.overflow = "visible";

        // Make sure event content is visible
        const content = event.querySelector(".rbc-event-content");
        if (content) {
          // Create a more structured content
          const originalText = content.textContent.trim();
          // Split into name and time if possible
          const lines = originalText
            .split(/\n|–|-/)
            .map((line) => line.trim())
            .filter(Boolean);

          if (lines.length > 0) {
            // Clear existing content
            content.innerHTML = "";

            // Add customer name in bold
            const nameDiv = document.createElement("div");
            nameDiv.textContent = lines[0];
            nameDiv.style.fontWeight = "bold";
            nameDiv.style.fontSize = "13px";
            nameDiv.style.marginBottom = "3px";
            nameDiv.style.lineHeight = "1.2";
            content.appendChild(nameDiv);

            // Add time info if available
            if (lines.length > 1) {
              const timeDiv = document.createElement("div");
              timeDiv.textContent = lines.slice(1).join(" ");
              timeDiv.style.fontSize = "12px";
              timeDiv.style.lineHeight = "1.1";
              content.appendChild(timeDiv);
            }
          }

          // Ensure content is visible
          content.style.overflow = "visible";
          content.style.whiteSpace = "normal";
          content.style.wordBreak = "break-word";
        }
      });

      // Fix time gutter
      const timeGutter = calendarClone.querySelector(".rbc-time-gutter");
      if (timeGutter) {
        timeGutter.style.width = "80px";
        timeGutter.style.minWidth = "80px";
        timeGutter.style.fontSize = "14px";
        timeGutter.style.color = "#4a5568";
        timeGutter.style.textAlign = "right";
        timeGutter.style.paddingRight = "10px";
      }

      // Set calendar size
      calendarClone.style.height = "1800px";
      calendarClone.style.width = "100%";
      calendarClone.style.border = "1px solid #e2e8f0";
      calendarClone.style.overflow = "hidden";

      exportContainer.appendChild(calendarClone);

      // Create canvas
      const canvas = await html2canvas(exportContainer, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        width: 1600,
        height: 1900,
        allowTaint: true,
        logging: false,
      });

      // Convert to image and download
      const image = canvas.toDataURL("image/png", 1.0);

      const filename = sportName
        ? `${sportName}_Calendar_${moment(selectedDate).format(
            "YYYY-MM-DD"
          )}.png`
        : `Calendar_${moment(selectedDate).format("YYYY-MM-DD")}.png`;

      const link = document.createElement("a");
      link.href = image;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      document.body.removeChild(exportContainer);
      toast.dismiss();
      toast.success("Calendar exported successfully");
    } catch (error) {
      console.error("Error exporting calendar:", error);
      toast.dismiss();
      toast.error("Failed to export calendar");
    }
  };

  const _renderTimeInputModal = () => (
    <div>
      <Formik
        onSubmit={(values) => {
          setShowTimeModal(false);
          handleExportAvailabilityWithDateRange(
            values.startDateTime,
            values.endDateTime
          );
        }}
        validationSchema={formTimeInputValidations}
        enableReinitialize
        initialValues={{
          startDateTime: (() => {
            const today = moment();
            const selected = moment(selectedDate);

            if (selected.format("YYYY-MM-DD") === today.format("YYYY-MM-DD")) {
              // Current date - round current time to next 30 minutes
              const currentMinutes = today.minute();
              let roundedMinutes;
              if (currentMinutes === 0 || currentMinutes === 30) {
                roundedMinutes = currentMinutes;
              } else if (currentMinutes < 30) {
                roundedMinutes = 30;
              } else {
                today.add(1, "hour");
                roundedMinutes = 0;
              }
              today.minute(roundedMinutes).second(0);
              return today.format("YYYY-MM-DDTHH:mm");
            } else {
              // Other date - start from 00:00
              return selected.format("YYYY-MM-DD") + "T00:00";
            }
          })(),
          endDateTime: (() => {
            const today = moment();
            const selected = moment(selectedDate);

            if (selected.format("YYYY-MM-DD") === today.format("YYYY-MM-DD")) {
              // Current date - current time + 12 hours, then round off
              const endTime = today.add(12, "hours");
              const minutes = endTime.minute();
              let roundedMinutes;
              if (minutes === 0 || minutes === 30) {
                roundedMinutes = minutes;
              } else if (minutes < 15) {
                roundedMinutes = 0;
              } else if (minutes < 45) {
                roundedMinutes = 30;
              } else {
                endTime.add(1, "hour");
                roundedMinutes = 0;
              }
              endTime.minute(roundedMinutes).second(0);
              return endTime.format("YYYY-MM-DDTHH:mm");
            } else {
              // Other date - 23:59
              return selected.format("YYYY-MM-DD") + "T23:59";
            }
          })(),
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formikProps) => (
          <>
            <div className="mb-3">
              <FormikInput
                formikProps={formikProps}
                name={"startDateTime"}
                placeholder={"Start Date Time"}
                label={"Start Date Time"}
                type={"datetime-local"}
                className="w-full"
                onChange={(value) => {
                  if (value) {
                    const rounded = moment(value);
                    const minutes = rounded.minute();
                    if (minutes !== 0 && minutes !== 30) {
                      // Round to nearest 30 minutes
                      const roundedMinutes =
                        minutes < 15 ? 0 : minutes < 45 ? 30 : 0;
                      if (roundedMinutes === 0 && minutes >= 45) {
                        rounded.add(1, "hour");
                      }
                      rounded.minute(roundedMinutes).second(0);
                      formikProps.setFieldValue(
                        "startDateTime",
                        rounded.format("YYYY-MM-DDTHH:mm")
                      );
                    } else {
                      formikProps.setFieldValue("startDateTime", value);
                    }
                  } else {
                    formikProps.setFieldValue("startDateTime", value);
                  }
                }}
              />
            </div>

            <div className="mb-3">
              <FormikInput
                formikProps={formikProps}
                name={"endDateTime"}
                placeholder={"End Date Time"}
                label={"End Date Time"}
                type={"datetime-local"}
                className="w-full"
                onChange={(value) => {
                  if (value) {
                    const rounded = moment(value);
                    const minutes = rounded.minute();
                    const hours = rounded.hour();
                    // Allow 00, 30 minutes or 23:59
                    if (
                      minutes !== 0 &&
                      minutes !== 30 &&
                      !(hours === 23 && minutes === 59)
                    ) {
                      // Round to nearest 30 minutes or 23:59
                      let roundedMinutes;
                      if (minutes < 15) {
                        roundedMinutes = 0;
                      } else if (minutes < 45) {
                        roundedMinutes = 30;
                      } else if (hours === 23) {
                        // For 23:xx, if >= 45 minutes, round to 23:59
                        roundedMinutes = 59;
                      } else {
                        // For other hours, round up to next hour
                        rounded.add(1, "hour");
                        roundedMinutes = 0;
                      }
                      rounded.minute(roundedMinutes).second(0);
                      formikProps.setFieldValue(
                        "endDateTime",
                        rounded.format("YYYY-MM-DDTHH:mm")
                      );
                    } else {
                      formikProps.setFieldValue("endDateTime", value);
                    }
                  } else {
                    formikProps.setFieldValue("endDateTime", value);
                  }
                }}
              />
            </div>

            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Button
                color="success"
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                className="shadow-md mr-3"
              >
                Export
              </Button>
              <Button
                color="secondary"
                className="secondary"
                onClick={() => setShowTimeModal(false)}
              >
                Cancel
              </Button>
            </div>
          </>
        )}
      </Formik>
    </div>
  );

  const handleExportAvailability = () => {
    setShowTimeModal(true);
  };

  const handleExportAvailabilityWithDateRange = async (
    startDateTime,
    endDateTime
  ) => {
    try {
      toast.loading("Preparing availability export...");

      // Create export container
      const exportContainer = document.createElement("div");
      exportContainer.style.position = "absolute";
      exportContainer.style.left = "-9999px";
      exportContainer.style.top = "-9999px";
      exportContainer.style.width = "1100px";
      exportContainer.style.backgroundColor = "#ffffff";
      exportContainer.style.padding = "40px";
      exportContainer.style.fontFamily = '"Segoe UI", "Roboto", sans-serif';
      exportContainer.style.borderRadius = "8px";
      exportContainer.style.boxShadow = "0 4px 6px rgba(0,0,0,0.1)";
      document.body.appendChild(exportContainer);

      // Get sport name and club name
      let sportName = "";
      try {
        const sportSelect = document.querySelector('select[name="sportId"]');
        if (sportSelect && sportSelect.selectedIndex >= 0) {
          sportName =
            sportSelect.options[sportSelect.selectedIndex].text.trim();
        } else if (selectedSport && sports && sports.length > 0) {
          const sportObj = sports.find(
            (s) =>
              s.value?.toString() === selectedSport?.toString() ||
              s.id?.toString() === selectedSport?.toString()
          );
          if (sportObj) {
            sportName = sportObj.label || sportObj.name || sportObj.text;
          }
        }
      } catch (e) {
        console.error("Error getting sport name:", e);
      }

      const clubName = global?.myClub?.name || "Club";

      // Main header - Sport On Availability
      const mainHeader = document.createElement("h1");
      mainHeader.textContent = `${clubName}  Availability (${sportName})`;
      mainHeader.style.fontSize = "32px";
      mainHeader.style.fontWeight = "bold";
      mainHeader.style.color = "#0C1B3A";
      mainHeader.style.textAlign = "center";
      mainHeader.style.marginBottom = "10px";
      mainHeader.style.textTransform = "uppercase";
      mainHeader.style.letterSpacing = "1px";
      exportContainer.appendChild(mainHeader);

      // By PlayPro subheading
      const subHeader = document.createElement("h4");
      subHeader.textContent = "by PlayPro";
      subHeader.style.fontSize = "20px";
      subHeader.style.fontWeight = "500";
      subHeader.style.color = "#0C1B3A";
      subHeader.style.textAlign = "center";
      subHeader.style.marginBottom = "15px";
      exportContainer.appendChild(subHeader);

      // Date range header
      const dateHeader = document.createElement("h3");
      const headerStartMoment = moment(startDateTime);
      const headerEndMoment = moment(endDateTime);

      let dateRangeText;
      if (
        headerStartMoment.format("YYYY-MM-DD") ===
        headerEndMoment.format("YYYY-MM-DD")
      ) {
        // Same date - show date only once
        dateRangeText = `${headerStartMoment.format(
          "DD/MM/YYYY"
        )} ${headerStartMoment.format("h:mm A")} - ${headerEndMoment.format(
          "h:mm A"
        )}`;
      } else {
        // Different dates - show both dates
        dateRangeText = `${headerStartMoment.format(
          "DD/MM/YYYY h:mm A"
        )} - ${headerEndMoment.format("DD/MM/YYYY h:mm A")}`;
      }

      dateHeader.textContent = dateRangeText;
      dateHeader.style.fontSize = "18px";
      dateHeader.style.fontWeight = "500";
      dateHeader.style.color = "#4a5568";
      dateHeader.style.textAlign = "center";
      dateHeader.style.marginBottom = "30px";
      exportContainer.appendChild(dateHeader);

      // Divider
      const divider = document.createElement("div");
      divider.style.height = "2px";
      divider.style.backgroundColor = "#e2e8f0";
      divider.style.width = "100%";
      divider.style.marginBottom = "30px";
      exportContainer.appendChild(divider);

      // Get courts and bookings data using date range
      const formattedStartDateTime =
        moment(startDateTime).format(ToCSharpFormat);
      const formattedEndDateTime = moment(endDateTime).format(ToCSharpFormat);
      const response = await common.ApiService.getInstance().request(
        `GetCourtWiseBookingsByDateRange?sportId=${selectedSport}&fromDateTime=${formattedStartDateTime}&endDateTime=${formattedEndDateTime}`
      );

      if (response.status !== respEnum.Success) {
        toast.error("Failed to fetch availability data");
        document.body.removeChild(exportContainer);
        return;
      }

      // Create availability container
      const availabilityContainer = document.createElement("div");
      availabilityContainer.style.marginBottom = "30px";
      exportContainer.appendChild(availabilityContainer);

      // Add court availability heading
      const availabilityHeading = document.createElement("h3");
      availabilityHeading.textContent = "Courts Availability";
      availabilityHeading.style.fontSize = "20px";
      availabilityHeading.style.fontWeight = "600";
      availabilityHeading.style.marginBottom = "20px";
      availabilityHeading.style.color = "#1a202c";
      availabilityContainer.appendChild(availabilityHeading);

      const courtsData = response.data || [];
      const availabilityData = [];

      // Debug: log the courts data
      console.log("Courts Data Received:", courtsData);

      courtsData.forEach((court) => {
        const courtName = court.courtName;
        const availableSlots = [];

        // Debug: log each court's bookings
        console.log(
          `Processing Court: ${courtName}, Bookings:`,
          court.bookings
        );

        // Sort bookings by start time
        const sortedBookings = court.bookings.sort(
          (a, b) =>
            moment(a.startDateTime).valueOf() -
            moment(b.startDateTime).valueOf()
        );

        const rangeStart = moment(startDateTime).clone();
        const rangeEnd = moment(endDateTime).clone();

        // Find gaps between bookings
        let currentTime = rangeStart.clone();

        sortedBookings.forEach((booking, index) => {
          const bookingStart = moment(booking.startDateTime);
          const bookingEnd = moment(booking.endDateTime);

          // If there's a gap before this booking
          if (currentTime.isBefore(bookingStart)) {
            const gapStart = currentTime.clone();
            const gapEnd = bookingStart.clone();

            // Make sure gap is within our date range
            if (gapEnd.isAfter(rangeStart) && gapStart.isBefore(rangeEnd)) {
              const effectiveStart = moment.max(gapStart, rangeStart);
              const effectiveEnd = moment.min(gapEnd, rangeEnd);

              if (effectiveStart.isBefore(effectiveEnd)) {
                let formattedSlot;
                if (
                  effectiveStart.format("YYYY-MM-DD") ===
                  effectiveEnd.format("YYYY-MM-DD")
                ) {
                  // Same day - show only times, no date
                  const formattedStart = effectiveStart.format("h:mm A");
                  const formattedEnd = effectiveEnd.format("h:mm A");
                  formattedSlot = `${formattedStart} - ${formattedEnd}`;
                } else {
                  // Different days - show both days with dates
                  const formattedStart =
                    effectiveStart.format("ddd DD/MM h:mm A");
                  const formattedEnd = effectiveEnd.format("ddd DD/MM h:mm A");
                  formattedSlot = `${formattedStart} - ${formattedEnd}`;
                }
                availableSlots.push(formattedSlot);
              }
            }
          }

          // Move current time to end of this booking
          if (bookingEnd.isAfter(currentTime)) {
            currentTime = bookingEnd.clone();
          }
        });

        // If no bookings at all, entire range is available
        if (sortedBookings.length === 0) {
          let formattedSlot;
          if (
            rangeStart.format("YYYY-MM-DD") === rangeEnd.format("YYYY-MM-DD")
          ) {
            // Same day - show only times, no date
            const formattedStart = rangeStart.format("h:mm A");
            const formattedEnd = rangeEnd.format("h:mm A");
            formattedSlot = `${formattedStart} - ${formattedEnd}`;
          } else {
            // Different days - show both days with dates
            const formattedStart = rangeStart.format("ddd DD/MM h:mm A");
            const formattedEnd = rangeEnd.format("ddd DD/MM h:mm A");
            formattedSlot = `${formattedStart} - ${formattedEnd}`;
          }
          availableSlots.push(formattedSlot);
        } else {
          // Check for availability after the last booking until range end
          if (currentTime.isBefore(rangeEnd)) {
            const gapStart = currentTime.clone();
            const gapEnd = rangeEnd.clone();

            if (gapStart.isBefore(gapEnd)) {
              let formattedSlot;
              if (
                gapStart.format("YYYY-MM-DD") === gapEnd.format("YYYY-MM-DD")
              ) {
                // Same day - show only times, no date
                const formattedStart = gapStart.format("h:mm A");
                const formattedEnd = gapEnd.format("h:mm A");
                formattedSlot = `${formattedStart} - ${formattedEnd}`;
              } else {
                // Different days - show both days with dates
                const formattedStart = gapStart.format("ddd DD/MM h:mm A");
                const formattedEnd = gapEnd.format("ddd DD/MM h:mm A");
                formattedSlot = `${formattedStart} - ${formattedEnd}`;
              }
              availableSlots.push(formattedSlot);
            }
          }
        }

        // Debug: log availability for this court
        console.log(`Court ${courtName} availability:`, availableSlots);

        if (availableSlots.length > 0) {
          availabilityData.push({
            courtName,
            slots: availableSlots,
          });
        }
      });

      // Debug: log final availability data
      console.log("Final Availability Data:", availabilityData);

      debugger;
      // Create court availability cards
      if (availabilityData.length === 0) {
        const noAvailability = document.createElement("div");
        noAvailability.textContent = "No courts available at this time.";
        noAvailability.style.padding = "20px";
        noAvailability.style.textAlign = "center";
        noAvailability.style.color = "#718096";
        noAvailability.style.fontStyle = "italic";
        availabilityContainer.appendChild(noAvailability);
      } else {
        // Create a grid for court cards
        const courtGrid = document.createElement("div");
        courtGrid.style.display = "grid";
        courtGrid.style.gridTemplateColumns = "repeat(2, 1fr)";
        courtGrid.style.gap = "20px";
        availabilityContainer.appendChild(courtGrid);

        availabilityData.forEach((court) => {
          // Create court card
          const courtCard = document.createElement("div");
          courtCard.style.backgroundColor = "#f9fafb";
          courtCard.style.border = "1px solid #e2e8f0";
          courtCard.style.borderRadius = "8px";
          courtCard.style.padding = "15px";
          courtCard.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
          courtGrid.appendChild(courtCard);

          // Court name header
          const courtNameHeader = document.createElement("h4");
          courtNameHeader.textContent = court.courtName;
          courtNameHeader.style.fontSize = "18px";
          courtNameHeader.style.fontWeight = "600";
          courtNameHeader.style.color = "#2d3748";
          courtNameHeader.style.marginBottom = "12px";
          courtNameHeader.style.padding = "0 0 8px 0";
          courtNameHeader.style.borderBottom = "1px solid #e2e8f0";
          courtCard.appendChild(courtNameHeader);

          // Available slots list
          const slotsList = document.createElement("ul");
          slotsList.style.listStyleType = "none";
          slotsList.style.padding = "0";
          slotsList.style.margin = "0";
          slotsList.style.marginTop = "8px";
          courtCard.appendChild(slotsList);

          court.slots.forEach((slot) => {
            const slotItem = document.createElement("li");
            slotItem.style.padding = "8px 12px";
            slotItem.style.margin = "4px 0";
            slotItem.style.backgroundColor = "#10b981";
            slotItem.style.color = "white";
            slotItem.style.borderRadius = "4px";
            slotItem.style.fontSize = "14px";
            slotItem.style.fontWeight = "500";
            slotItem.style.display = "flex";
            slotItem.style.alignItems = "center";
            slotItem.style.boxSizing = "border-box";
            slotItem.style.border = "none";
            slotItem.style.outline = "none";

            // Add clock icon
            const clockIcon = document.createElement("span");
            clockIcon.textContent = "🕒";
            clockIcon.style.marginRight = "10px";
            clockIcon.style.fontSize = "16px";
            clockIcon.style.flexShrink = "0";
            slotItem.appendChild(clockIcon);

            // Add time text
            const timeText = document.createElement("span");
            timeText.textContent = slot;
            timeText.style.lineHeight = "1.2";
            timeText.style.flex = "1";
            slotItem.appendChild(timeText);

            slotsList.appendChild(slotItem);
          });
        });
      }

      // Create canvas from the container
      const canvas = await html2canvas(exportContainer, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        width: 1100,
        height: Math.min(1800, 350 + availabilityData.length * 120),
        allowTaint: true,
        logging: false,
      });

      // Convert to image and download
      const image = canvas.toDataURL("image/png", 1.0);

      const filename = sportName
        ? `${sportName}_Availability_${moment(startDateTime).format(
            "YYYY-MM-DD_HHmm"
          )}_to_${moment(endDateTime).format("YYYY-MM-DD_HHmm")}.png`
        : `PlayPro_Availability_${moment(startDateTime).format(
            "YYYY-MM-DD_HHmm"
          )}_to_${moment(endDateTime).format("YYYY-MM-DD_HHmm")}.png`;

      const link = document.createElement("a");
      link.href = image;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      document.body.removeChild(exportContainer);
      toast.dismiss();
      toast.success("Availability exported successfully");
    } catch (error) {
      console.error("Error exporting availability:", error);
      toast.dismiss();
      toast.error("Failed to export availability");
    }
  };

  return (
    <div>
      <style>
        {`
          @media (max-width: 639px) {
         
                .export-availability-btn {
        height: 25px !important;
        width: auto !important;
        padding: 6px !important;
              font-size: 0.875rem !important;
            }
          }
        `}
      </style>
      <div className="min-h-screen flex flex-col items-centerx">
        <div className="md:grid md:grid-cols-4 grid grid-cols-2 gap-3 mb-5">
          <div className="flex flex-col gap-3">
            <AppSelect
              name={"sportId"}
              data={sports}
              value={selectedSport}
              placeholder={"Select Sport"}
              label={"Sport"}
              onChange={handleSportChange}
            />
          </div>

          <div className="flex flex-col gap-3 ">
            <AppInput
              value={moment(selectedDate).format(DateminFormat)}
              type={"date"}
              label={"Date"}
              onChange={handleDateChange}
            />
          </div>

          <div className="flex items-end col-span-2 gap-3 ">
            <div className="flex justify-center sm:justify-start gap-1 mx-auto sm:mx-0">
              {" "}
              <Button
                onClick={handleExportCalendar}
                className=" export-availability-btn bg-[#0C1B3A] text-white hover:bg-[#1a2b4d] px-4 py-2 rounded"
              >
                Export Calendar
              </Button>
              <Button
                onClick={handleExportAvailability}
                className="export-availability-btn bg-[#047857] text-white hover:bg-[#065f46] px-4 py-2 rounded"
              >
                Export Availability
              </Button>
            </div>
          </div>
        </div>
        <div className="bg-white shadow-md py-3 rounded-lg w-full">
          <div className="h-100 p-0">
            <Calendar
              localizer={localizer}
              events={events}
              resources={resources}
              resourceIdAccessor="id"
              resourceTitleAccessor="title"
              views={["day"]}
              defaultView="day"
              selectable
              date={selectedDate}
              onNavigate={handleNavigate}
              onSelectSlot={(slotInfo) => {
                if (!isSlotOverlapping(slotInfo, events)) {
                  handleSelect(slotInfo);
                }
              }}
              components={{
                event: CustomEvent,
              }}
              style={{ height: "100%" }}
              eventPropGetter={(event) => ({
                className: getEventClassName(event),
              })}
            />
          </div>
        </div>
      </div>
      <AddUpdateModal
        open={showAdd}
        setOpen={setShowAdd}
        Component={(props) => (
          <AddBooking
            {...props}
            onClose={_handleOnClose}
            bookingValues={{
              ...bookingValues,
              paymentStatus: PaymentStatusEnum.Un_Paid,
              bookingDate: moment(selectedDate).format(DateminFormat),
            }}
          />
        )}
        title={"Create Booking"}
      />
      <DialogModal
        title={"Export Availability - Select Date Range"}
        open={showTimeModal}
        setOpen={setShowTimeModal}
        Child={_renderTimeInputModal}
        onClose={() => setShowTimeModal(false)}
      />
    </div>
  );
};

export default BookingCalendar2;
